<template>
  <div class="pt-4">
    <!-- Workload Stats Table Header Row -->
    <CustomTable
      :first-cell-image="true"
      :custom-class="`view-players-table workload-players-table double-image}`"
    >
      <template slot="theader">
        <TableRow>
          <TableCell :class="{'fixed-column first-col':scrollLeftOver25}">
            <div class="gear-btn-wrapper gear-stats">
              <b-btn :id="'metricInfoPopover_WorkloadStatsTable'" :class="'popover-btn non-clickabile-gear-btn'">
                <img src="@/assets/images/icons/gear-icon.png" alt="unit settings icon" />
              </b-btn>

              <div
                class="custom-popover table-settings-popover"
                id="popoverPlacement_WorkloadTable"
              ></div>

              <!-- <b-popover
                :target="'metricInfoPopover_WorkloadStatsTable'"
                triggers="click blur"
                placement="bottomright"
                container="popoverPlacement_WorkloadTable"
              >
                <div class="popover-content">
                  <div class="table-setting-row">
                    <div class="row-content">
                      {{ $t('CALENDAR_ACTIVITY.playerStatsTables.distanceSpeedTable.workload') }}
                      <div
                        class="btn-group calendar-view-filter switch-btn-group switch-btn-group-orange fa-pull-right"
                        @click="changeWorkloadZonesUnitOnClick()"
                      >
                        <label
                          class="btn"
                          :class="{ 'active': workloadZonesSelectedUnit === workloadZoneUnits.PERCENTAGE }"
                        >%</label>
                        <label
                          class="btn"
                          :class="{ 'active': workloadZonesSelectedUnit === workloadZoneUnits.TRIMPS }"
                        >TRIMPs</label>
                      </div>
                    </div>
                  </div>
                </div>
              </b-popover> -->
            </div>
            <span
              :class="{'d-none':scrollLeftOver25}"
            >{{ $t('CALENDAR_ACTIVITY.playerStatsTables.distanceSpeedTable.player') }}</span>
          </TableCell>
          <TableCell>{{ $t('CALENDAR_ACTIVITY.playerStatsTables.distanceSpeedTable.workload') }}</TableCell>
          <TableCell
            :custom-classes="'blue-column'"
          >{{ $t('CALENDAR_ACTIVITY.playerStatsTables.workloadStatsTable.low') }}</TableCell>
          <TableCell
            :custom-classes="'green-column'"
          >{{ $t('CALENDAR_ACTIVITY.playerStatsTables.workloadStatsTable.medium') }}</TableCell>
          <TableCell
            :custom-classes="'orange-column'"
          >{{ $t('CALENDAR_ACTIVITY.playerStatsTables.workloadStatsTable.high') }}</TableCell>
          <TableCell
            :custom-classes="'red-column'"
          >{{ $t('CALENDAR_ACTIVITY.playerStatsTables.workloadStatsTable.max') }}</TableCell>
          <TableCell
            class="text-uppercase"
          >{{ $t('CALENDAR_ACTIVITY.playerStatsTables.distanceSpeedTable.numberOfSprints') }}</TableCell>
        </TableRow>
      </template>
    </CustomTable>
    <!-- Workload Stats Table With Values -->
    <CustomTable
      :first-cell-image="true"
      :custom-class="`accordion-table view-players-table workload-players-table double-image`"
    >
      <template slot="tbody">
        <TableRow>
          <TableCell :class="{'fixed-column data-col':scrollLeftOver25}">
            <PlayerInvalidActivityIcon :activity-status="activityInfo.status" />

            <span
              class="battery-warnings"
              v-if="!scrollLeftOver25 && activityInfo.batteryLevelIsLow"
              v-b-tooltip="{
                title: this.$t('CALENDAR_ACTIVITY.playerStatsTables.batteryWarningsTooltip') ,
                container: 'body',
                boundary: 'viewport',
                trigger: 'hover',
                template: tooltipTemplate,
                placement: 'topright'
              }"
            >
              <img src="@/assets/images/activity/10_battery.png" alt="battery warning" />
            </span>

            <span
              v-if="!scrollLeftOver25 && activityInfo.sensorError"
              v-b-tooltip="{
                title: this.$t('CALENDAR_ACTIVITY.playerStatsTables.sensorError'),
                container: 'body',
                boundary: 'viewport',
                trigger: 'hover',
                template: tooltipTemplate,
                placement: 'topright'
              }"
              class="other-img error-icon cursor-pointer text-error"
            >
              <i class="fas fa-minus-circle" aria-hidden="true"></i>
            </span>

            <img
              class="player-icon cell-img"
              v-if="activityInfo.playerPhoto"
              :src="activityInfo.playerPhoto"
              alt="player photo"
            />

            <CustomEmblem
              v-if="!activityInfo.playerPhoto"
              :gender="activityInfo.playerGender"
              :sub-header="[activityInfo.playerFirstName, activityInfo.playerLastName]"
              :custom-classes="'cell-img'"
              id="tooltip-player-ds"
            />
            <span
              :class="{'d-none':scrollLeftOver25}"
            >{{ activityInfo.playerFirstName }} {{ activityInfo.playerLastName }}</span>
            <b-tooltip
              v-if="scrollLeftOver25"
              target="tooltip-player-ds"
              triggers="hover"
            >{{activityInfo.playerFirstName}} {{activityInfo.playerLastName}}</b-tooltip>
          </TableCell>
          <!-- workload -->
          <TableCell>
            <template v-if="data.invalid">{{$t('COMMON.notApplicable')}}</template>
            <template v-if="!data.invalid">
              <template v-if="data.workload !== null">{{ data.workload | number }}</template>
              <template v-if="data.workload === null ">{{ $t('COMMON.notApplicable') }}</template>
            </template>
          </TableCell>
          <!-- Low Intensity -->
          <TableCell :custom-classes="'blue-column'">
            <template v-if="data.invalid">{{$t('COMMON.notApplicable')}}</template>
            <!-- Low Intensity Percentage -->
            <template
              v-if="workloadZonesSelectedUnit === workloadZoneUnits.PERCENTAGE && !data.invalid"
            >
              <template
                v-if="data.lowIntensityZonePercentage != null"
              >{{ `${data.lowIntensityZonePercentage}%` }}</template>
              <template
                v-if="data.lowIntensityZonePercentage === null"
              >{{$t('COMMON.notApplicable')}}</template>
            </template>
            <!-- Low Intensity Trimps -->
            <template
              v-if="workloadZonesSelectedUnit === workloadZoneUnits.TRIMPS && !data.invalid"
            >
              <template
                v-if="data.lowIntensityZone != null"
              >{{ data.lowIntensityZone | number }} TRIMPs</template>
              <template v-if="data.lowIntensityZone === null">{{$t('COMMON.notApplicable')}}</template>
            </template>
          </TableCell>
          <!-- Medium Intensity -->
          <TableCell :custom-classes="'green-column'">
            <template v-if="data.invalid">{{$t('COMMON.notApplicable')}}</template>
            <!-- Medium Intensity Percentage -->
            <template
              v-if="workloadZonesSelectedUnit === workloadZoneUnits.PERCENTAGE && !data.invalid"
            >
              <template
                v-if="data.mediumIntensityZonePercentage != null"
              >{{ `${data.mediumIntensityZonePercentage}%` }}</template>
              <template
                v-if="data.mediumIntensityZonePercentage === null"
              >{{$t('COMMON.notApplicable')}}</template>
            </template>
            <!-- Medium Intensity Trimps -->
            <template
              v-if="workloadZonesSelectedUnit === workloadZoneUnits.TRIMPS && !data.invalid"
            >
              <template
                v-if="data.mediumIntensityZone != null"
              >{{ data.mediumIntensityZone | number }} TRIMPs</template>
              <template v-if="data.mediumIntensityZone === null">{{$t('COMMON.notApplicable')}}</template>
            </template>
          </TableCell>
          <!-- High Intensity -->
          <TableCell :custom-classes="'orange-column'">
            <template v-if="data.invalid">{{$t('COMMON.notApplicable')}}</template>
            <!-- High Intensity Percentage -->
            <template
              v-if="workloadZonesSelectedUnit === workloadZoneUnits.PERCENTAGE && !data.invalid"
            >
              <template
                v-if="data.highIntensityZonePercentage != null"
              >{{ `${data.highIntensityZonePercentage}%` }}</template>
              <template
                v-if="data.highIntensityZonePercentage === null"
              >{{$t('COMMON.notApplicable')}}</template>
            </template>
            <!-- High Intensity Trimps -->
            <template
              v-if="workloadZonesSelectedUnit === workloadZoneUnits.TRIMPS && !data.invalid"
            >
              <template
                v-if="data.highIntensityZone != null"
              >{{ data.highIntensityZone | number }} TRIMPs</template>
              <template v-if="data.highIntensityZone === null">{{$t('COMMON.notApplicable')}}</template>
            </template>
          </TableCell>
          <!-- Max Intensity -->
          <TableCell :custom-classes="'red-column'">
            <template v-if="data.invalid">{{$t('COMMON.notApplicable')}}</template>
            <!-- Max Intensity Percentage -->
            <template
              v-if="workloadZonesSelectedUnit === workloadZoneUnits.PERCENTAGE && !data.invalid"
            >
              <template
                v-if="data.maxIntensityZonePercentage != null"
              >{{ `${data.maxIntensityZonePercentage}%` }}</template>
              <template
                v-if="data.maxIntensityZonePercentage === null"
              >{{$t('COMMON.notApplicable')}}</template>
            </template>
            <!-- Max Intensity Trimps -->
            <template
              v-if="workloadZonesSelectedUnit === workloadZoneUnits.TRIMPS && !data.invalid"
            >
              <template
                v-if="data.maxIntensityZone != null"
              >{{ data.maxIntensityZone | number }} TRIMPs</template>
              <template v-if="data.maxIntensityZone === null">{{$t('COMMON.notApplicable')}}</template>
            </template>
          </TableCell>
          <!-- Number of sprints -->
          <TableCell>
            <template v-if="data.invalid">{{$t('COMMON.notApplicable')}}</template>
            <template
              v-if="!data.invalid"
            >{{ data.numberOfSprints !== null ? data.numberOfSprints : $t('COMMON.notApplicable') }}</template>
          </TableCell>
        </TableRow>
      </template>
    </CustomTable>
    <!-- Segments Table -->
    <CustomTable
      v-for="segment in statsSegment"
      :key="segment.id"
      :first-cell-image="true"
      :custom-class="`accordion-table view-players-table workload-players-table double-image`"
    >
      <template slot="tbody">
        <TableRow>
          <TableCell :class="{'fixed-column data-col':scrollLeftOver25}">
            <PlayerInvalidActivityIcon :activity-status="activityInfo.status" />

            <img
              class="player-icon cell-img"
              v-if="activityInfo.playerPhoto"
              :src="activityInfo.playerPhoto"
              alt="player photo"
            />

            <CustomEmblem
              v-if="!activityInfo.playerPhoto"
              :gender="activityInfo.playerGender"
              :sub-header="[activityInfo.playerFirstName, activityInfo.playerLastName]"
              :custom-classes="'cell-img'"
              id="tooltip-segment-ds"
            />
            <span
              :class="{'d-none':scrollLeftOver25}"
            >{{segment.name}} ({{(segment.endPoint - segment.startPoint) | secondsToMinutesSeconds}})</span>
            <b-tooltip
              v-if="scrollLeftOver25"
              target="tooltip-segment-ds"
              triggers="hover"
            >{{activityInfo.playerFirstName}} {{activityInfo.playerLastName}}</b-tooltip>
          </TableCell>
          <!-- Workload Segments-->
          <TableCell>
            <template v-if="segment.segmentStats.invalid">{{$t('COMMON.notApplicable')}}</template>

            <template v-if="!segment.segmentStats.invalid">
              <template
                v-if="segment.segmentStats.workload !== null"
              >{{ segment.segmentStats.workload | number }} TRIMPs</template>
              <template
                v-if="segment.segmentStats.workload === null "
              >{{ $t('COMMON.notApplicable') }}</template>
            </template>
          </TableCell>
          <!-- Low Intensity Segments-->
          <TableCell :custom-classes="'blue-column'">
            <template v-if="segment.segmentStats.invalid">{{$t('COMMON.notApplicable')}}</template>
            <!-- Low Intensity Percentage Segments-->
            <template
              v-if="workloadZonesSelectedUnit === workloadZoneUnits.PERCENTAGE && !segment.segmentStats.invalid"
            >
              <template
                v-if="segment.segmentStats.lowIntensityZonePercentage != null"
              >{{ `${segment.segmentStats.lowIntensityZonePercentage}%` }}</template>
              <template
                v-if="segment.segmentStats.lowIntensityZonePercentage === null"
              >{{$t('COMMON.notApplicable')}}</template>
            </template>
            <!-- Low Intensity Trimps Segments-->
            <template
              v-if="workloadZonesSelectedUnit === workloadZoneUnits.TRIMPS && !segment.segmentStats.invalid"
            >
              <template
                v-if="segment.segmentStats.lowIntensityZone != null"
              >{{ segment.segmentStats.lowIntensityZone | number }} TRIMPs</template>
              <template
                v-if="segment.segmentStats.lowIntensityZone === null"
              >{{$t('COMMON.notApplicable')}}</template>
            </template>
          </TableCell>
          <!-- Medium Intensity Segments-->
          <TableCell :custom-classes="'green-column'">
            <template v-if="segment.segmentStats.invalid">{{$t('COMMON.notApplicable')}}</template>
            <!-- Medium Intensity Percentage Segments-->
            <template
              v-if="workloadZonesSelectedUnit === workloadZoneUnits.PERCENTAGE && !segment.segmentStats.invalid"
            >
              <template
                v-if="segment.segmentStats.mediumIntensityZonePercentage != null"
              >{{ `${segment.segmentStats.mediumIntensityZonePercentage}%` }}</template>
              <template
                v-if="segment.segmentStats.mediumIntensityZonePercentage === null"
              >{{$t('COMMON.notApplicable')}}</template>
            </template>
            <!-- Medium Intensity Trimps Segments-->
            <template
              v-if="workloadZonesSelectedUnit === workloadZoneUnits.TRIMPS && !segment.segmentStats.invalid"
            >
              <template
                v-if="segment.segmentStats.mediumIntensityZone != null"
              >{{ segment.segmentStats.mediumIntensityZone | number }} TRIMPs</template>
              <template
                v-if="segment.segmentStats.mediumIntensityZone === null"
              >{{$t('COMMON.notApplicable')}}</template>
            </template>
          </TableCell>

          <!-- High Intensity Segments-->
          <TableCell :custom-classes="'orange-column'">
            <template v-if="data.invalid">{{$t('COMMON.notApplicable')}}</template>
            <!-- High Intensity Percentage Segments -->
            <template
              v-if="workloadZonesSelectedUnit === workloadZoneUnits.PERCENTAGE && !segment.segmentStats.invalid"
            >
              <template
                v-if="segment.segmentStats.highIntensityZonePercentage != null"
              >{{ `${segment.segmentStats.highIntensityZonePercentage}%` }}</template>
              <template
                v-if="segment.segmentStats.highIntensityZonePercentage === null"
              >{{$t('COMMON.notApplicable')}}</template>
            </template>
            <!-- High Intensity Trimps Segments-->
            <template
              v-if="workloadZonesSelectedUnit === workloadZoneUnits.TRIMPS && !segment.segmentStats.invalid"
            >
              <template
                v-if="segment.segmentStats.highIntensityZone != null"
              >{{ segment.segmentStats.highIntensityZone | number }} TRIMPs</template>
              <template
                v-if="segment.segmentStats.highIntensityZone === null"
              >{{$t('COMMON.notApplicable')}}</template>
            </template>
          </TableCell>

          <!-- Max Intensity Segments-->
          <TableCell :custom-classes="'red-column'">
            <template v-if="data.invalid">{{$t('COMMON.notApplicable')}}</template>
            <!-- Max Intensity Percentage Segments -->
            <template
              v-if="workloadZonesSelectedUnit === workloadZoneUnits.PERCENTAGE && !segment.segmentStats.invalid"
            >
              <template
                v-if="segment.segmentStats.maxIntensityZonePercentage != null"
              >{{ `${segment.segmentStats.maxIntensityZonePercentage}%` }}</template>
              <template
                v-if="segment.segmentStats.maxIntensityZonePercentage === null"
              >{{$t('COMMON.notApplicable')}}</template>
            </template>
            <!-- Max Intensity Trimps Segments-->
            <template
              v-if="workloadZonesSelectedUnit === workloadZoneUnits.TRIMPS && !segment.segmentStats.invalid"
            >
              <template
                v-if="segment.segmentStats.maxIntensityZone != null"
              >{{ segment.segmentStats.maxIntensityZone | number }} TRIMPs</template>
              <template
                v-if="segment.segmentStats.maxIntensityZone === null"
              >{{$t('COMMON.notApplicable')}}</template>
            </template>
          </TableCell>
          <!-- Number of Sprints Segments-->
          <TableCell>
            <template v-if="segment.segmentStats.invalid">{{$t('COMMON.notApplicable')}}</template>
            <template
              v-if="!segment.segmentStats.invalid"
            >{{ segment.segmentStats.numberOfSprints !== null ? segment.segmentStats.numberOfSprints : $t('COMMON.notApplicable') }}</template>
          </TableCell>
        </TableRow>
      </template>
    </CustomTable>
  </div>
</template>

<script>
import { SESSION_METRICS } from "@/constants/SessionConsts";
import { CustomTable, TableRow, TableCell } from "@/components/common/table";
import CustomEmblem from "@/components/common/CustomEmblem";
import { WORKLOAD_ZONES_UNITS } from "@/constants/SessionConsts";
import PlayerInvalidActivityIcon from "@/components/calendar-activity/PlayerInvalidActivityIcon";

export default {
  name: "WorkloadStatsTable",
  props: [
    "data",
    "activityInfo",
    "changeWorkloadZonesUnit",
    "workloadZonesSelectedUnit",
    "distanceChartUnit",
    "currentMetric",
    "statsSegment",
    "scrollLeftOver25",
  ],
  data() {
    return {
      workloadZoneUnits: WORKLOAD_ZONES_UNITS,
      SESSION_METRICS: SESSION_METRICS,
      tooltipTemplate:
        '<div class="tooltip event-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
    };
  },
  methods: {
    changeWorkloadZonesUnitOnClick() {
      const newUnit =
        this.workloadZonesSelectedUnit === this.workloadZoneUnits.PERCENTAGE
          ? this.workloadZoneUnits.TRIMPS
          : this.workloadZoneUnits.PERCENTAGE;
      this.changeWorkloadZonesUnit(newUnit);
    },
  },
  components: {
    CustomTable,
    TableRow,
    TableCell,
    CustomEmblem,
    PlayerInvalidActivityIcon,
  },
};
</script>

<style lang="scss" scoped>
.workload-players-table {
  .table-cell {
    &:first-child {
      width: 27%;
    }

    &:nth-child(n + 2) {
      width: 13%;
    }
  }
}
.non-clickabile-gear-btn {
  &:hover {
    cursor: default;
  }
}
</style>
